import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { IMAGES } from "@/lib/data";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Lavage à pression professionnel"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-secondary/85 via-secondary/70 to-black/60" />
      </div>

      <div className="container-x relative z-10 pt-24 pb-16">
        <div className="max-w-3xl fade-in-up">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-sm mb-8">
            <ShieldCheck className="w-4 h-4 text-primary" />
            <span>Résidentiel & commercial • Québec</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.05] tracking-tight">
            Redonnez une apparence <span className="text-primary">neuve</span> à votre propriété.
          </h1>

          <p className="mt-6 text-lg sm:text-xl text-white/85 max-w-2xl leading-relaxed">
            Service professionnel de lavage à pression pour maisons, entrées, patios, terrasses,
            commerces et plus. Résultats impeccables.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Button
              data-testid="hero-cta-quote"
              asChild
              size="lg"
              className="bg-primary hover:bg-primary/90 text-white rounded-xl px-8 py-6 text-base font-semibold group"
            >
              <a href="#contact">
                Obtenir une soumission
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </a>
            </Button>
            <Button
              data-testid="hero-cta-book"
              asChild
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-sm text-white border-white/30 hover:bg-white hover:text-secondary rounded-xl px-8 py-6 text-base font-semibold"
            >
              <a href="#reservation">Réserver maintenant</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
